import React from "react";

import { LGSectionContainer } from "./SectionContainer";
import { SectionType } from "../../types";
import CustomContentCard from "../customCards";

export const CardBannerLg = ({
    cards
}: SectionType): JSX.Element => (
    <LGSectionContainer>
        {cards?.length && (
            <CustomContentCard {...cards[0]} />
        )}
    </LGSectionContainer>
)